export const getPubNubService = ({ publishKey, subscribeKey }) => {
  const pubNubObj = {};

  return async (userId) => {
    const { default: PubNub } = await import(/* webpackChunkName: "PubNub-vendor" */ "pubnub");
    if (!pubNubObj[userId]) pubNubObj[userId] = new PubNub({ publishKey, subscribeKey, userId });
    return pubNubObj[userId];
  };
};

export { PubnubProvider, usePubnubData, withPubnub } from "./context";
